export default __webpack_public_path__ + "static/media/box-arrow-up_white.c37388fe.svg";